if (!customElements.get('discount-code-field')) {
  customElements.define(
    'discount-code-field',
    class DiscountCodeField extends HTMLElement {
      constructor() {
        super();
        this.elements = {};

        this.onFormSubmit = this.onSubmit.bind(this);
        this.onSummaryClick = this.handleSummaryToggle.bind(this);
      }

      connectedCallback() {
        // Query elements only after the component is added to the DOM
        this.elements = {
          form: this.querySelector('form'),
          submitButton: this.querySelector('button[type="submit"]'),
          buttonSpinnerWrap: this.querySelector('button[type="submit"] .discount-code__spinner-wrap'),
          buttonSpinner: this.querySelector('button[type="submit"] .loading__spinner'),
          errorMessage: this.querySelector('.discount-code-field__error-message'),
          discountInput: this.querySelector('input[name="discount"]'),
          detailsCloseButton: this.parentElement?.querySelector('.discount-code-field-details__close'),
          detailsIcon: this.parentElement?.querySelector('.discount-code-field-details__icon'),
          detailsSummary: this.parentElement?.querySelector('summary'),
        };

        this.registerEventListeners();
      }

      registerEventListeners() {
        // Form Submission
        this.elements.form?.addEventListener('submit', this.onFormSubmit);

        // Hide error message on input
        this.elements.discountInput?.addEventListener('input', () => {
          if (this.elements.errorMessage) this.elements.errorMessage.style.display = 'none';
        });

        // Summary/Details Toggle logic
        if (this.elements.detailsSummary) {
          this.elements.detailsSummary.addEventListener('click', this.onSummaryClick);
        }
      }

      handleSummaryToggle() {
        // We check the 'open' attribute on the parent (usually a <details> tag)
        const isOpen = this.parentElement.hasAttribute('open');
        
        this.elements.detailsCloseButton?.classList.toggle('hidden', isOpen);
        this.elements.detailsCloseButton?.classList.toggle('u-flex', !isOpen);

        this.elements.detailsIcon?.classList.toggle('hidden', !isOpen);
        this.elements.detailsIcon?.classList.toggle('u-flex', isOpen);
        this.elements.detailsSummary.setAttribute('aria-expanded', String(!isOpen));
      }

      setLoadingState(isLoading) {
        if (!this.elements.submitButton) return;

        if (isLoading) {
          this.elements.submitButton.disabled = true;
          this.elements.buttonSpinner?.classList.remove('hidden');
          this.elements.buttonSpinnerWrap?.classList.remove('hidden');
        } else {
          this.elements.submitButton.disabled = false;
          this.elements.buttonSpinner?.classList.add('hidden');
          this.elements.buttonSpinnerWrap?.classList.add('hidden');
        }
      }

      onSubmit(event) {
        event.preventDefault();

        const formData = new FormData(this.elements.form);
        const discountCode = formData.get('discount')?.trim();

        if (!discountCode) return;

        this.setLoadingState(true);

        addRemoveDiscountCodes([discountCode], [])
          .then((response) => {
            const result = response?.discount_codes || [];

            const isAccepted = result
              .filter((code) => String(code.code).toLowerCase() === String(discountCode).toLowerCase())
              .some((code) => code.applicable);

            if (!isAccepted) {
              if (this.elements.errorMessage) this.elements.errorMessage.style.display = 'block';
            } else {
              this.elements.form.reset();
              if (typeof publish === 'function') {
                publish(PUB_SUB_EVENTS.cartUpdate, { source: 'discount-code-field' });
              }
            }
          })
          .catch((error) => {
            console.error('Error applying discount code:', error);
            if (this.elements.errorMessage) this.elements.errorMessage.style.display = 'block';
          })
          .finally(() => {
            this.setLoadingState(false);
          });
      }

      disconnectedCallback() {
        // Cleanup to prevent memory leaks if the element is removed
        this.elements.form?.removeEventListener('submit', this.onFormSubmit);
        this.elements.detailsSummary?.removeEventListener('click', this.onSummaryClick);
      }
    },
  );
}